// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"ContentWrapper-module--contentWrapper--1BPSf"};